import { render, staticRenderFns } from "./CommandAssistantDashboardDev.vue?vue&type=template&id=1853b27f&scoped=true&"
import script from "./CommandAssistantDashboardDev.vue?vue&type=script&lang=js&"
export * from "./CommandAssistantDashboardDev.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistantDashboardDev.vue?vue&type=style&index=0&id=1853b27f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853b27f",
  null
  
)

export default component.exports